module.exports = __webpack_public_path__ + "img/firepots.7fd55107.jpg";